var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv ng-cloak\u003E\u003Calert-list type=\"fund-transfers\"\u003E\u003C\u002Falert-list\u003E\u003Cdiv class=\"transfer-funds\"\u003E\u003Ch2\u003ETransfer funds\u003C\u002Fh2\u003E\u003Csection\u003E\u003Cp class=\"explanation\"\u003EEnter your \u003Cb\u003Eunique\u003C\u002Fb\u003E investor BPAY details below to transfer money via Internet banking.\u003Chelp-mate topic=\"fund-transfers\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fp\u003E\u003Cbpay-details ng-if=\"vm.bpay\" biller-code=\"vm.bpay.billerCode\" crn=\"vm.bpay.crn\"\u003E\u003C\u002Fbpay-details\u003E\u003Cp\u003E\u003Cspan\u003EIf you would prefer a different payment method, please call\u003C\u002Fspan\u003E\u003Ctenant-anchor anchor-id=\"contact.telephone.main\"\u003E\u003C\u002Ftenant-anchor\u003E\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection\u003E\u003Chr\u003E\u003C\u002Fsection\u003E\u003Csection\u003E\u003Ch2\u003EWhen will my funds be available?\u003C\u002Fh2\u003E\u003Cp\u003EYour bank account will be debited immediately, but BPAY transfers typically take 1-2 Banking Business\nDays to complete.\n\nBPAY payments made before your bank’s cut-off time (usually 6pm AEST) on a Banking Business Day will\nbe available in your dashboard the following business day.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003E\u003Cb\u003EExample 1:\u003C\u002Fb\u003E Transfer made at 3pm Tuesday; funds received 11am Wednesday.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cb\u003EExample 2:\u003C\u002Fb\u003E Transfer made at 8pm Friday (after the cut-off); funds received 11am Tuesday.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003EFor more information, see the\n\u003Ca href=\"https:\u002F\u002Fwww.bpay.com.au\u002FHelp-Centre\u002FPersonal-User\u002FBPAY-Services-FAQs.aspx\" target=\"_blank\"\u003EBPAY website\u003C\u002Fa\u003E\n\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"withdraw-funds\" ng-if=\"vm.isOwner\"\u003E\u003Ch2\u003EWithdraw available funds\u003C\u002Fh2\u003E\u003Cwithdrawal-request\u003E\u003C\u002Fwithdrawal-request\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;